/**
 * Copies the text specified in `data-copy-text` to the clipboard
 * when an element with the `copy-to-clipboard-on-click` attribute is clicked.
 *
 * Optionally, a notification can be shown when the text is copied by specifying the
 * notification content in a `data-on-copy-notification-text` attribute.
 */

import notifier from "../services/notifier";

function initCopyToClipboardOnClick() {
  const elements = document.querySelectorAll(
    "[copy-to-clipboard-on-click]"
  ) as NodeListOf<HTMLElement>;

  elements.forEach((element) => {
    const copyText = element.dataset["copyText"];
    const onCopyNotificationText = element.dataset["onCopyNotificationText"];

    if (copyText) {
      element.addEventListener("click", () => {
        navigator.clipboard.writeText(copyText);

        if (onCopyNotificationText) {
          notifier.success(onCopyNotificationText);
        }
      });
    } else {
      console.warn("data-copy-text must be specified for element", element);
    }
  });
}

document.addEventListener("DOMContentLoaded", initCopyToClipboardOnClick);
